var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogocopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 44,
    viewBox: "0 0 59 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3419 32.7487L51.8515 7.02196C50.5449 1.84127 44.8922 -0.918112 40.0039 1.23822L29.4263 5.90114L18.8487 1.23822C13.9604 -0.918112 8.30759 1.84127 7.001 7.02196L0.510677 32.7487C-1.14312 39.303 5.03959 45.1263 11.4842 43.0857L28.0496 37.8411V30.3122C25.6405 29.496 23.9075 27.2178 23.9075 24.5315C23.9075 21.16 26.6395 18.428 30.011 18.428C33.3826 18.428 36.1146 21.16 36.1146 24.5315C36.1146 27.3122 34.2537 29.6574 31.7075 30.3944V33.2848H33.4953V35.8157H31.7075V38.1243L47.3713 43.0857C53.816 45.1263 59.9956 39.303 58.3449 32.7487H58.3419Z",
    fill: "#228A22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogocopy);
export default __webpack_public_path__ + "static/media/logo copy.5fb2645d6ef7e845f5b724886b66c258.svg";
export { ForwardRef as ReactComponent };